import PropTypes from "prop-types";

export const Card = ({ children, className = "" }) => {
  return <div className={`app-card ${className}`}>{children}</div>;
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
